// CVE-2024-4367 (pdf.js < 4.2.67): un PDF malicioso puede ejecutar JavaScript en el navegador al
// renderizar sus fuentes. isEvalSupported: false desactiva esa vía. Usar en todo pdfjs.getDocument
// y en el prop `options` de <Document> (react-pdf).
export const PDFJS_SAFE_OPTIONS = { isEvalSupported: false };
